var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1027_86406)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1027_86406",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.373535 0H16.3735V16H0.373535V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1027_86406)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1027_86406",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.373535 0H16.3735V16H0.373535V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1027_86406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2698 9.138H2.47509C2.1731 9.138 1.88347 9.01803 1.66993 8.80448C1.45639 8.59094 1.33643 8.30132 1.33643 7.99933C1.33643 7.69734 1.45639 7.40771 1.66993 7.19417C1.88347 6.98063 2.1731 6.86066 2.47509 6.86066H14.2698C14.5718 6.86066 14.8614 6.98063 15.0749 7.19417C15.2885 7.40771 15.4084 7.69734 15.4084 7.99933C15.4084 8.30132 15.2885 8.59094 15.0749 8.80448C14.8614 9.01803 14.5718 9.138 14.2698 9.138Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37308 15.0367C8.14769 15.0369 7.9273 14.9702 7.73984 14.845C7.55238 14.7199 7.40628 14.5419 7.32004 14.3337C7.2338 14.1254 7.21131 13.8963 7.2554 13.6752C7.2995 13.4542 7.4082 13.2512 7.56775 13.092L12.6604 7.99932L7.56775 2.90665C7.46199 2.80089 7.3781 2.67534 7.32086 2.53717C7.26363 2.39899 7.23417 2.25088 7.23417 2.10131C7.23417 1.79925 7.35416 1.50958 7.56775 1.296C7.78134 1.08241 8.07102 0.962418 8.37308 0.962418C8.67514 0.962418 8.96483 1.08241 9.17842 1.296L15.0764 7.19399C15.1822 7.29973 15.2661 7.42527 15.3234 7.56345C15.3806 7.70163 15.4101 7.84975 15.4101 7.99932C15.4101 8.1489 15.3806 8.29699 15.3234 8.43518C15.2661 8.57336 15.1822 8.69892 15.0764 8.80466L9.17842 14.7027C9.07288 14.8087 8.94737 14.8929 8.80915 14.9502C8.67093 15.0075 8.52272 15.0369 8.37308 15.0367Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1027_86406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.373535)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c8234be076d5f4854c4d89d1ba637991.svg";
export { ForwardRef as ReactComponent };